import { render, staticRenderFns } from "./WsSortItem.vue?vue&type=template&id=aa9d5200&scoped=true&"
import script from "./WsSortItem.vue?vue&type=script&lang=js&"
export * from "./WsSortItem.vue?vue&type=script&lang=js&"
import style0 from "./WsSortItem.vue?vue&type=style&index=0&id=aa9d5200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9d5200",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
